import { LOCAL_STORAGE_VALUES } from "./Constants/keys";
import { roles } from "./Constants/roles";
import { Domain } from "./DomainSwitcher/domains";

export const selfPacedRoles = [
  roles.SELF_PACED_PRODUCT_MANAGER_STUDENT,
  roles.SELF_PACED_SCRUM_MASTER_STUDENT,
  roles.SELF_PACED_PRODUCT_OWNER_STUDENT,
  roles.SELF_PACED_BUSINESS_ANALYST_STUDENT,
  roles.SELF_PACED_AGILE_PROJECT_MANAGER_STUDENT,
  roles.AI_BUSINESS_ANALYST_STUDENT,
  roles.AA_ICP_PDM_CERTIFCATION,
  roles.AA_ICP_CERTIFCATION,
];
export const hasAnyFreeRole = (rolesList: string[] = []) =>
  rolesList.includes(roles.FREE_SELF_PACED_BUSINESS_ANALYST_STUDENT) ||
  rolesList.includes(roles.FREE_SELF_PACED_PRODUCT_OWNER_STUDENT);

export const trialRoles = [
  roles.BUISNESS_ANALYST_STUDENT,
  roles.SCRUM_MASTER_STUDENT,
  roles.PRODUCT_OWNER_STUDENT,
];

const validateAIBusinessAnalyst = (authState: any) => {
  return authState?.tac_user?.all_roles?.includes(
    roles.AI_BUSINESS_ANALYST_STUDENT
  );
};

export const isFreeSelfPacedUser = (authState: any) => {
  const isFree = hasAnyFreeRole(authState?.tac_user?.all_roles);
  return isFree;
};

/* SELF PACED USER -> in all_roles there are multiple roles */
export const checkSelfPacedExistInAllRoles = (authState: any) => {
  return selfPacedRoles.some((role) =>
    authState?.tac_user?.all_roles?.includes(role)
  );
};

/* NORNAL USER -> in all_roles there are single role */
export const checkNormalUser = (authState: any) => {
  const hasFreeRole = isFreeSelfPacedUser(authState);
  return (
    authState?.tac_user?.role === roles.USER &&
    authState.userType === LOCAL_STORAGE_VALUES.NORMAL_USER &&
    !hasFreeRole
  );
};

export const isSelfPacedRole = (role: any, authState: any) => {
  return selfPacedRoles.includes(role) || validateAIBusinessAnalyst(authState);
};

export const checkMultipleRoleExist = (authState: any) => {
  return authState?.tac_user?.all_roles?.length > 1;
};

export const checkRemoveApPi = (authState: any) => {
  const roles = authState?.tac_user?.all_roles || [];

  const freeRoles = [
    "free_self_paced_business_analyst",
    "free_self_paced_product_owner",
  ];

  return roles.some((r: string) => freeRoles.includes(r));
};

export const checkSelfPacedOrMultiRoleUser = (authState: any) => {
  return (
    (authState.userType !== LOCAL_STORAGE_VALUES.NORMAL_USER &&
      checkSelfPacedExistInAllRoles(authState)) ||
    isSelfPacedRole(authState?.tac_user?.role, authState)
  );
};

export const isTrialRole = (role: any) => trialRoles.includes(role);

export const validateTAAUser = (authState: any, configState: any) => {
  const role = authState?.tac_user?.role;
  const isTAA = configState?.configs?.membership_enabled === Domain.TAA;
  return (
    isTAA &&
    (role === roles.USER ||
      isSelfPacedRole(role, authState) ||
      hasAnyFreeRole(authState?.tac_user?.all_roles))
  );
};

export const validateTrialUser = (authState: any, configState: any) => {
  const role = authState?.tac_user?.role;
  const isTAA = configState?.configs?.membership_enabled === Domain.TAA;
  return (
    isTAA && isTrialRole(role) && authState?.tac_user?.default_password_updated
  );
};

export const isSelfPacedStudentWithTAA = (authState: any, configState: any) => {
  return (
    (isSelfPacedRole(authState?.tac_user?.role, authState) ||
      hasAnyFreeRole(authState?.tac_user?.all_roles)) &&
    configState?.configs?.membership_enabled === Domain.TAA
  );
};
